import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

export const useWaypointStore = defineStore("waypoints", () => {
  const waypoints = ref([]);
  const isLoading = ref(false);

  // Start travel
  const startWaypoint = async (id) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.put(`/api/waypoints/${id}/start`);
      const updatedWaypoint = response.data.waypoint;
      const index = waypoints.value.findIndex((waypoint) => waypoint.id === id);
      if (index !== -1) {
        waypoints.value[index] = updatedWaypoint;
      }
    } catch (err) {
      throw err.response?.data?.message || "Failed to start waypoint";
    } finally {
      isLoading.value = false;
    }
  };

  return {
    waypoints,
    isLoading,
    startWaypoint,
  };
});
